import { openDB } from 'idb'

const client = {}

client.databaseName = "database"

client.databaseVersion = 5

client.open = async function () {
  return openDB(client.databaseName, client.databaseVersion, {
    upgrade(db, oldVersion, newVersion, transaction, event) {
      console.log(`Upgrading local database from v${oldVersion} to v${event.newVersion}`)

      // Upgrade to version 1
      if (oldVersion < 1) {
        console.log('Creating version 1 database schema...')
        db.createObjectStore("auth", { keyPath: "id" })
        const syncLogsStore = db.createObjectStore("sync_logs", { keyPath: "id" })
        syncLogsStore.createIndex("created_at", "created_at")
        syncLogsStore.createIndex("type, created_at", ["type", "created_at"])

        const ordersStore = db.createObjectStore("orders", { keyPath: "id" })
        ordersStore.createIndex("location_id, master, created_at", ["location_id", "master", "created_at"])
        ordersStore.createIndex("location_id, st_jeans_num, created_at", ["location_id", "st_jeans_num", "created_at"])
        ordersStore.createIndex("location_id, ship_first_name, created_at", ["location_id", "ship_to.first_name", "created_at"])
        ordersStore.createIndex("location_id, ship_last_name, created_at", ["location_id", "ship_to.last_name", "created_at"])
        ordersStore.createIndex("location_id, ship_street_address, created_at", ["location_id", "ship_to.street_address", "created_at"])
        ordersStore.createIndex("location_id, ship_city, created_at", ["location_id", "ship_to.city", "created_at"])
        ordersStore.createIndex("location_id, ship_state, created_at", ["location_id", "ship_to.state", "created_at"])
        ordersStore.createIndex("location_id, ship_zip, created_at", ["location_id", "ship_to.zip", "created_at"])
        ordersStore.createIndex("location_id, ship_country, created_at", ["location_id", "ship_to.country", "created_at"])
        ordersStore.createIndex("location_id, ship_phone, created_at", ["location_id", "ship_to.phone", "created_at"])
        ordersStore.createIndex("location_id, ship_email, created_at", ["location_id", "ship_to.email", "created_at"])
        ordersStore.createIndex("location_id, bill_first_name, created_at", ["location_id", "bill_to.first_name", "created_at"])
        ordersStore.createIndex("location_id, bill_last_name, created_at", ["location_id", "bill_to.last_name", "created_at"])
        ordersStore.createIndex("location_id, bill_street_address, created_at", ["location_id", "bill_to.street_address", "created_at"])
        ordersStore.createIndex("location_id, bill_city, created_at", ["location_id", "bill_to.city", "created_at"])
        ordersStore.createIndex("location_id, bill_state, created_at", ["location_id", "bill_to.state", "created_at"])
        ordersStore.createIndex("location_id, bill_zip, created_at", ["location_id", "bill_to.zip", "created_at"])
        ordersStore.createIndex("location_id, bill_country, created_at", ["location_id", "bill_to.country", "created_at"])
        ordersStore.createIndex("location_id, bill_phone, created_at", ["location_id", "bill_to.phone", "created_at"])
        ordersStore.createIndex("location_id, bill_email, created_at", ["location_id", "bill_to.email", "created_at"])
        ordersStore.createIndex("location_id, fishing_license, created_at", ["location_id", "fishing_license", "created_at"])
        ordersStore.createIndex("location_id, ordered_at, created_at", ["location_id", "ordered_at", "created_at"])
        ordersStore.createIndex("location_id, status, created_at", ["location_id", "status", "created_at"])
        ordersStore.createIndex("location_id, confirmed_at, created_at", ["location_id", "confirmed_at", "created_at"])
        ordersStore.createIndex("location_id, shipped_at, created_at", ["location_id", "shipped_at", "created_at"])
        ordersStore.createIndex("location_id, received_at, created_at", ["location_id", "received_at", "created_at"])
        ordersStore.createIndex("location_id, trip_code, created_at", ["location_id", "trip_code", "created_at"])
        ordersStore.createIndex("location_id, fish_tag, created_at", ["location_id", "fish_tag", "created_at"])
        ordersStore.createIndex("location_id, manifest_id, created_at", ["location_id", "manifest_id", "created_at"])

        const manifestsStore = db.createObjectStore("manifests", { keyPath: "id" })
        manifestsStore.createIndex("location_id, manifest_num, created_at", ["location_id", "manifest_num", "created_at"])
        manifestsStore.createIndex("location_id, status, created_at", ["location_id", "status", "created_at"])
        manifestsStore.createIndex("location_id, created_at, created_at", ["location_id", "created_at", "created_at"]) // This one is silly but it does let me use a consistent pattern
        manifestsStore.createIndex("location_id, updated_at, created_at", ["location_id", "updated_at", "created_at"])
        manifestsStore.createIndex("location_id, closed_at, created_at", ["location_id", "closed_at", "created_at"])
        manifestsStore.createIndex("location_id, shipped_at, created_at", ["location_id", "shipped_at", "created_at"])

        const customersStore = db.createObjectStore("customers", { keyPath: "id" })
        customersStore.createIndex("location_id, first_name, created_at", ["location_id", "first_name", "created_at"])
        customersStore.createIndex("location_id, last_name, created_at", ["location_id", "last_name", "created_at"])
        customersStore.createIndex("location_id, created_at, created_at", ["location_id", "created_at", "created_at"]) // This one is silly but it does let me use a consistent pattern
        customersStore.createIndex("location_id, email, created_at", ["location_id", "email", "created_at"])
        customersStore.createIndex("location_id, phone, created_at", ["location_id", "phone", "created_at"])
        customersStore.createIndex("location_id, ship_street_address, created_at", ["location_id", "ship_to.street_address", "created_at"])
        customersStore.createIndex("location_id, ship_city, created_at", ["location_id", "ship_to.city", "created_at"])
        customersStore.createIndex("location_id, ship_state, created_at", ["location_id", "ship_to.state", "created_at"])
        customersStore.createIndex("location_id, ship_zip, created_at", ["location_id", "ship_to.zip", "created_at"])
        customersStore.createIndex("location_id, ship_country, created_at", ["location_id", "ship_to.country", "created_at"])
        customersStore.createIndex("location_id, bill_street_address, created_at", ["location_id", "bill_to.street_address", "created_at"])
        customersStore.createIndex("location_id, bill_city, created_at", ["location_id", "bill_to.city", "created_at"])
        customersStore.createIndex("location_id, bill_state, created_at", ["location_id", "bill_to.state", "created_at"])
        customersStore.createIndex("location_id, bill_zip, created_at", ["location_id", "bill_to.zip", "created_at"])
        customersStore.createIndex("location_id, bill_country, created_at", ["location_id", "bill_to.country", "created_at"])
        customersStore.createIndex("location_id, ship_phone, created_at", ["location_id", "ship_to.phone", "created_at"])
        customersStore.createIndex("location_id, fishing_license, created_at", ["location_id", "fishing_license", "created_at"])
        customersStore.createIndex("location_id, trip_code, created_at", ["location_id", "trip_code", "created_at"])
        customersStore.createIndex("location_id, fish_tag, created_at", ["location_id", "fish_tag", "created_at"])

        db.createObjectStore("locations", { keyPath: "id" })
        db.createObjectStore("species", { keyPath: "id" })
        db.createObjectStore("processes", { keyPath: "id" })
        db.createObjectStore("weighinprocesses", { keyPath: "id" })
        db.createObjectStore("options", { keyPath: "id" })
        db.createObjectStore("files", { keyPath: "url" })
        const apiQueueStore = db.createObjectStore("api_queue", { keyPath: "id" })
        apiQueueStore.createIndex("handle", "handle") // Points to a different api_queue ID that this request depends on
        apiQueueStore.createIndex("location_id, date", ["location_id", "date"])

        const offlineOrdersStore = db.createObjectStore("offline_orders", { keyPath: "id" })
        offlineOrdersStore.createIndex("location_id, created_at", ["location_id", "created_at"])
      }

      // Upgrade to version 2
      if (oldVersion < 2) {
        console.log('Adding console logs store for version 2...')
        const consoleLogsStore = db.createObjectStore("console_logs", { keyPath: "id" })
        consoleLogsStore.createIndex("timestamp", "timestamp")
        consoleLogsStore.createIndex("level, timestamp", ["level", "timestamp"])
        consoleLogsStore.createIndex("source, timestamp", ["source", "timestamp"])
      }

      // Upgrade to version 3
      if (oldVersion < 3) {
        console.log('Adding featureflags store for version 3...')
        db.createObjectStore("featureflags", { keyPath: "key" })
      }

      // Upgrade to version 4
      if (oldVersion < 4) {
        console.log('Adding new V2 IDB schema for version 4...')
        const ordersStore = transaction.objectStore("orders")
        ordersStore.createIndex("location_id, company, created_at", ["location_id", "company", "created_at"])
        ordersStore.createIndex("location_id, first_name, created_at", ["location_id", "first_name", "created_at"])
        ordersStore.createIndex("location_id, last_name, created_at", ["location_id", "last_name", "created_at"])
        ordersStore.createIndex("location_id, email, created_at", ["location_id", "email", "created_at"])
        ordersStore.createIndex("location_id, phone, created_at", ["location_id", "phone", "created_at"])
        ordersStore.createIndex("location_id, customer_id, created_at", ["location_id", "customer_id", "created_at"])
      }

      // Upgrade to version 5
      if (oldVersion < 5) {
        console.log('Adding tripcodes store for version 5...')
        const tripCodesStore = db.createObjectStore("tripcodes", { keyPath: "id" })
        tripCodesStore.createIndex("year, latest_order_at", ["year", "latest_order_at"])
      }
    }
  })
}

export default client